import { Group } from 'NSwag/ServerClient/Client.nswag';
import { Action } from 'redux';

export enum GroupActionTypes {
    AddGroups = "ADD_GROUPS",
    ModifyGroups = "MODIFY_GROUPS"
}

export interface AddGroups extends Action {
    type: GroupActionTypes.AddGroups;
    groups: Group[];
}

export interface ModifyGroups extends Action{
    type: GroupActionTypes.ModifyGroups;
    groups: Group[];
}